const T = 1e3, o = 3;
export {
  o as TOASTS_LIMIT,
  T as TOAST_DURATION
};
